import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class AnomalieInterPonctuelleEvent extends UserEvent {
  public static NAME = 'ANOMALIE_INTER_PONCTUELLE';

  constructor(
    public idVacation: string,
    public texte: string,
    public photos: string[],
    public avecZone: boolean,
    public idZone: string | undefined,
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(AnomalieInterPonctuelleEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: AnomalieInterPonctuelleEvent): AnomalieInterPonctuelleEvent {
    return new AnomalieInterPonctuelleEvent(
      obj.idVacation,
      obj.texte,
      obj.photos,
      obj.avecZone,
      obj.idZone,
      dayjs(obj.instant),
      obj.coordinates
    );
  }
}
